// @ts-strict-ignore
import { FaqDetailPage as Page } from '@components/_faq-detail/Page'
import { nlCategorySlugToEn } from '@components/_faq/questions'
import { getServerSideTranslations } from '@lib/get-server-side-translations'
import { getPageByCodename } from '@lib/kontent'
import { SingleItemResponse } from '@lib/kontent/fetchContent'
import { FaqPage as FaqPageModel } from '@lib/kontent/models/FaqPage'
import { GetStaticPaths, GetStaticProps, NextPage } from 'next'

type Props = SingleItemResponse<FaqPageModel> & {
  slug: string
}

const FaqDetailPage: NextPage<Props> = ({ item, slug, modular_content }) => {
  return <Page item={item} slug={slug} modular_content={modular_content} />
}

export default FaqDetailPage

export const getStaticProps: GetStaticProps = async ({ locale, params, preview, ...rest }) => {
  const slug = typeof params.slug === 'string' ? params.slug : params.slug.join('/')
  const content = await getPageByCodename<FaqPageModel>({
    codename: 'faq_page',
    lang: locale,
    preview,
  })
  return {
    props: {
      ...content,
      ...(await getServerSideTranslations(locale)),
      slug,
    },
  }
}

export const getStaticPaths: GetStaticPaths = async ({ locales, ...rest }) => {
  let paths = []
  // These are the url slugs for the faq detail pages.
  const faqSlugsNl = Object.keys(nlCategorySlugToEn)
  const faqSlugsEn = Object.values(nlCategorySlugToEn)

  for (const locale of locales) {
    const faqSlugs = locale === 'nl' ? faqSlugsNl : faqSlugsEn
    faqSlugs.forEach((item) => {
      paths.push({
        params: {
          slug: [item],
        },
        locale,
      })
    })
  }

  return { paths, fallback: false }
}
